var map = {
	"./alfa0logo.jpg": 89,
	"./alfa1.jpg": 90,
	"./alfa2.jpg": 91,
	"./alfa3.png": 92,
	"./loreal0logo.jpg": 93,
	"./loreal1.jpg": 94,
	"./loreal2.jpg": 95,
	"./loreal3.jpg": 96,
	"./loreal4.jpg": 97,
	"./oasis0logo.png": 98,
	"./oasis1.jpg": 99,
	"./oasis2.png": 100,
	"./oasis3.jpg": 101,
	"./revlon0logo.jpg": 102,
	"./revlon1.jpg": 103,
	"./revlon2.png": 104,
	"./revlon3.jpg": 105,
	"./revlon4.jpg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;